module.exports = "<div class=\"d-flex check-dropdown-select-wrapper\"><label class=\"gmc-checkbox d-flex align-items-center justify-content-center\"><input type=checkbox gmc-indeterminate={{$ctrl.indeterminate}} ng-model=$ctrl.checked ng-change=$ctrl.isChecked()> <span class=gmc-checkbox__checkbox></span></label> <span class=\"d-flex align-items-center mr-2\">Select all</span></div>";


//////////////////
// WEBPACK FOOTER
// ./app/ui/check-dropdown-select/check-dropdown-select.component.html
// module id = 891
// module chunks = 31